import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import BasicSettingIndex from "../../../../components/SidetabPages/Configuration/BasicSetting/BasicSettingIndex";

const BasicSetting = () => {
  return (
    <>
      <AnnouncementBar />
      <BasicSettingIndex />
    </>
  );
};
export default BasicSetting;
